export default "__VITE_ASSET__DNu7MHEh__"